import { render, staticRenderFns } from "./EditNationalEvent.vue?vue&type=template&id=1c2c3a83&"
import script from "./EditNationalEvent.vue?vue&type=script&lang=ts&"
export * from "./EditNationalEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports